import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Masonry from 'react-masonry-css';
import { Box, Button, Typography, Select, MenuItem } from '@mui/material';
import { InsertComment } from '@mui/icons-material';
import FeedbackService from 'services/FeedbackService';
import FormModal from '../FormModal';
import ThanksModal from '../ThanksModal';
import Card from '../Card';
import { useStyles } from './styles';
import { useAuthUser } from 'features/auth/AuthUserContext';

export default function List() {
  const classes = useStyles();
  const router = useRouter();
  const { isAuthenticated } = useAuthUser();
  const [filters, setFilters] = useState({ orderDirection: 'DESC' });
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [thanksModalOpen, setThanksModalOpen] = useState(false);
  const feedbackService = new FeedbackService();
  const [stats, setStats] = useState({ total: 0 });

  useEffect(() => {
    async function fetchPlatformStats() {
      try {
        const { data } = await feedbackService.getPlatformStats();

        setStats(data);
      } catch (e) {
        console.error(e);
      }
    }

    fetchPlatformStats();
  }, []);

  async function fetchData(page) {
    try {
      const response = await feedbackService.findAllPublic({
        orderDirection: filters.orderDirection,
        page,
        perPage: 12,
      });

      if (page === 1) {
        setData(response.data.data);
      } else {
        setData([...data, ...response.data.data]);
      }
    } catch (e) {
      console.error(e);
    }
  }

  function handleFormModalOpen() {
    if (!isAuthenticated) {
      router.push(`/auth/login-register?redirect=${encodeURIComponent(window.location.href)}`);
    } else {
      setFormModalOpen(true);
    }
  }

  function handleFormModalClose(hasCreated) {
    setFormModalOpen(false);

    if (hasCreated) {
      setThanksModalOpen(true);
    }
  }

  function handleShowMoreButtonClick() {
    const nextPage = currentPage + 1;

    setCurrentPage(nextPage);

    fetchData(nextPage);
  }

  useEffect(() => {
    setCurrentPage(1);

    fetchData(1);
  }, [filters]);

  return (
    <>
      <FormModal open={formModalOpen} onClose={handleFormModalClose} />

      <ThanksModal open={thanksModalOpen} onClose={() => setThanksModalOpen(false)} />

      <Box mb={2} display="flex" alignItems="center" justifyContent="space-between">
        <Box display="inline-flex" alignItems="center">
          <Typography component="span">Sort by:</Typography>

          <Select
            variant="standard"
            className={classes.input}
            classes={{ icon: classes.primaryColor }}
            value={filters.orderDirection}
            onChange={({ target: { value } }) => setFilters({ ...filters, orderDirection: value })}
          >
            <MenuItem value="DESC">Most recently</MenuItem>
            <MenuItem value="ASC">Older</MenuItem>
          </Select>
        </Box>

        <Button
          className={classes.button}
          startIcon={<InsertComment className={classes.primaryColor} />}
          onClick={handleFormModalOpen}
        >
          Write a review
        </Button>
      </Box>

      <Masonry
        breakpointCols={{
          default: 3,
          1000: 2,
          700: 1,
        }}
        className={classes.masonryRoot}
        columnClassName={classes.masonryColumn}
      >
        {data.map((feedback, index) => (
          <Card key={index} feedback={feedback} />
        ))}
      </Masonry>

      {data.length + 30 <= stats.total && (
        <Box mt={4} textAlign="center">
          <Button className={classes.buttonShowMore} onClick={handleShowMoreButtonClick}>
            Show more
          </Button>
        </Box>
      )}
    </>
  );
}
